import type { ColDef } from "ag-grid-enterprise";

// A grouped grid declares its per-column concerns on the leaves, which a flat `.map` over
// top-level defs never reaches — decorators must descend into `ColGroupDef.children`.
// A top-level def with no `children` is itself a leaf and gets `fn` applied directly.
export function mapColDefTree(defs: ColDef[], fn: (def: ColDef) => ColDef): ColDef[] {
  return defs.map((def) => {
    const children = (def as { children?: unknown }).children;
    if (!Array.isArray(children)) return fn(def);
    return { ...def, children: mapColDefTree(children as ColDef[], fn) };
  });
}
